
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ name: 'DttLoader' })
export default class Loader extends Vue {
  @Prop({ type: Boolean, default: false }) overlay!: boolean;
  @Prop({ type: String }) size!: string;
}
